import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import styles from './MiniMergeSections.module.css'
import {MiniMergeStatusItem} from './MiniMergeStatusItem'

export function MiniStatusSkeletonItem({
  text,
  action,
}: {
  text?: string
  action?: (returnFocusTo?: HTMLElement | null) => void
}) {
  return (
    <MiniMergeStatusItem aria-label="Loading merge status">
      <MiniMergeStatusItem.LabelRow>
        <span className="d-flex flex-items-center gap-1">
          {text ? (
            <MiniMergeStatusItem.Label>{text}</MiniMergeStatusItem.Label>
          ) : (
            <LoadingSkeleton variant="text" width="80px" />
          )}
        </span>

        {action ? (
          <MiniMergeStatusItem.Action aria-label="View details" onClick={event => action(event.currentTarget)} />
        ) : (
          <LoadingSkeleton variant="rounded" width="20px" height="20px" className={styles.MiniStatusLoadingIcon} />
        )}
      </MiniMergeStatusItem.LabelRow>
      <LoadingSkeleton className={styles.MiniStatusProgress} variant="rounded" height="8px" />
    </MiniMergeStatusItem>
  )
}
